import React from 'react'
import Modal from "react-bootstrap/Modal";
import { DropDownComponent } from "../../dropdown/DropDownComponent"
import { PlaceHolder } from "../../constants/PlaceHolderConstants"
import { PhoneNumberComponent } from '../../dropdown/PhoneNumberComponent';

function AddNewContactModal(props) {
    const { contactShow,
        setContactShow,
        HandleContactChange,
        contacttemp,
        setContactTemp,
        departmentdata,
        designationdata,
        HandleConDepChange,
        condepartment,
        HandleConDesChange,
        condesignation,
        HandleContactSubmit,
        setConDepartment,
        setConDesignation,
        contactError,
        contactClose,
        setContactError } = props;
    return (
        <Modal show={contactShow} centered size='xl' className='addNewContactModal'>
            <Modal.Header>
                <div className="">
                    <h6>New Contact</h6>
                </div>
                <div className="">
                    <i className="fas fa-times" onClick={contactClose}></i>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className='row'>
                    <div className='col-12'>
                        {contactError.contact && <p className="form-error">{contactError.contact}</p>}
                    </div>
                </div>
                <div className='row'>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                        <div>
                            <label>Contact Name <span className='mandatory'>*</span></label>
                            <input className='form-control' name="name" value={contacttemp.name} type="text" placeholder={PlaceHolder.CONTACT_NAME} onChange={HandleContactChange}></input>
                            {contactError.name && <p className="form-error">{contactError.name}</p>}
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                        <div>
                            <label>Email <span className='mandatory'>*</span></label>
                            <input className='form-control' type="text" placeholder={PlaceHolder.EMAIL} name="email" value={contacttemp.email} onChange={HandleContactChange}></input>
                            {contactError.email && <p className="form-error">{contactError.email}</p>}
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                        <div>
                            <label>Phone Number <span className='mandatory'>*</span></label>
                            <PhoneNumberComponent errors={contactError} setValues={setContactTemp} setErrors={setContactError} filedName="phone" values={contacttemp} />
                            {contactError.phone && <p className="form-error">{contactError.phone}</p>}
                        </div>
                    </div>

                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                        <div>
                            <label>Department <span className='mandatory'>*</span></label>
                            <DropDownComponent placeholder={PlaceHolder.SELECT_DEPARTMENT} pageName="company" dpDownName="department" controlName="departmentId" stateData={departmentdata} handleChange={HandleConDepChange} value={condepartment} valueId={contacttemp?.departmentId} setState={setConDepartment} />
                            {contactError.department && <p className="form-error">{contactError.department}</p>}
                        </div>
                    </div>
                    <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
                        <div>
                            <label>Designation <span className='mandatory'>*</span></label>
                            <DropDownComponent placeholder={PlaceHolder.SELECT_DESIGNATION} pageName="company" dpDownName="designation" controlName="designationId" stateData={designationdata} handleChange={HandleConDesChange} value={condesignation} valueId={contacttemp?.designationId} setState={setConDesignation} />
                            {contactError.designation && <p className="form-error">{contactError.designation}</p>}
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="text-right mt-3">
                            <button type="button" className="btn cancel-btn" onClick={contactClose}>Cancel</button>
                            <button type="button" className="btn save-btn" onClick={HandleContactSubmit}>{!contacttemp?.id ? 'Save' : 'Update'}</button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddNewContactModal